import { InhalerCompliance } from '@/jsonapi/CommonTypes'
import { GenericReading } from '@/jsonapi/SiteReadings'
import moment from 'moment-timezone'
import { GlucometerReadingCounts } from '@/jsonapi/SiteStats'

export function getSuccessRatePieChartOptions(readings: GlucometerReadingCounts, rangeDesc: String) {
  const total = readings.totalCount

  // let accepted = readings.filter(r => r.matchedPatientId != null).length
  let acceptedAndFixed = readings.matchedCount

  let corrected = readings.fixedOidSwapCount
  let acceptedWithoutCorrection = acceptedAndFixed - corrected

  // let noPid = readings.filter(r => (r.matchedPatientId == null && r.devicePatientId == '0') || !r.devicePatientId).length
  let noPid = readings.noPidCount

  // let QC = readings.filter(r => r.matchedPatientId == null && r.devicePatientId && r.devicePatientId == 'QC').length
  let QC = readings.qcCount

  //let invalidPid = total - accepted - noPid - QC
  let invalidPid = readings.invalidCount

  const totalWithoutQC = total - QC

  // const successPercent = total == 0 ? 0 : Math.round((1000 * accepted) / (total - QC)) / 10

  const successRate = total == 0 ? 0 : Math.round((1000 * acceptedAndFixed) / totalWithoutQC) / 10
  // const successPercent = total == 0 ? 0 : Math.round((1000 * success) / total) / 10
  const noPidPercent = total == 0 ? 0 : Math.round((1000 * noPid) / totalWithoutQC) / 10
  const invalidPidPercent = total == 0 ? 0 : Math.round((1000 * invalidPid) / totalWithoutQC) / 10
  // const qcPercent = total == 0 ? 0 : Math.round((1000 * QC) / total) / 10

  // const successText = `${successPercent}% Successful`
  const acceptedText =
    `${acceptedWithoutCorrection.toLocaleString('en-US')} Accepted` +
    (corrected > 0 ? `, ${corrected.toLocaleString('en-US')} Auto-corrected` : '')
  const noPidText = `${noPid.toLocaleString('en-US')} No PID` //`${noPidPercent}% No PID`
  const invalidPidText = `${invalidPid.toLocaleString('en-US')} Invalid PID` // `${invalidPidPercent}% Invalid PID`
  const qcText = `${QC.toLocaleString('en-US')} QC`

  return {
    title: {
      text: `${totalWithoutQC.toLocaleString('en-US')} Glucometer Readings ${rangeDesc}`,
      subtext: `+ ${QC.toLocaleString('en-US')} QC tests`,
      subtextStyle: {
        color: '#444',
      },
    },
    legend: {
      selectedMode: false,
      orient: 'vertical',
      right: 10,
      top: -5,
      silent: true,
      textStyle: {
        fontWeight: 'bold',
      },
      formatter: function(params) {
        return params
      },
      data: [acceptedText, noPidText, invalidPidText],
    },
    series: [
      {
        name: 'EMR success rate',
        type: 'pie',
        silent: true,
        radius: ['55%', '70%'],
        avoidLabelOverlap: true,
        itemStyle: {},
        label: {
          normal: {
            show: true,
            position: 'center',
            textStyle: {
              color: '#333',
              fontSize: '30',
            },
            formatter: function(params) {
              const { name, value } = params.data
              return `${name} \n ${value}%`
            },
          },
          // emphasis: {
          //   show: true,
          //   textStyle: {
          //     fontSize: '30',
          //     fontWeight: 'bold',
          //   },
          // },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
        data: [
          {
            value: successRate,
            name: acceptedText,

            // itemStyle: {color: '006838'}
            itemStyle: { normal: { color: '#5fd0d0' } },
            label: {
              position: 'center',
              textStyle: {
                color: '#74777a',
                fontSize: '40',
                fontWight: 'bold',
                fontFamily: 'Source Sans Pro',
              },
              formatter: function(params) {
                return totalWithoutQC == 0 ? `No readings\n${rangeDesc}` : `${successRate}%\nSuccess`
              },
            },
          },
          {
            value: noPidPercent,
            name: noPidText,
            itemStyle: { color: '#9a3f67' },
            label: { show: false },
          },
          {
            value: invalidPidPercent,
            name: invalidPidText,
            itemStyle: { color: '#603f9a' },
            label: { show: false },
          },
          // {
          //   value: qcPercent,
          //   name: qcText,
          //   itemStyle: { color: '#757575' },
          //   label: { show: false },
          // },
        ],
      },
    ],
  }
}
